import type { ReactNode } from 'react';

export interface TabDef {
  readonly id: string;
  readonly label: string;
  readonly badge?: ReactNode;
  readonly testId?: string;
}

export interface TabsProps {
  readonly tabs: readonly TabDef[];
  readonly activeId: string;
  readonly onSelect: (id: string) => void;
  readonly testId?: string;
}

export function Tabs({ tabs, activeId, onSelect, testId }: TabsProps): JSX.Element {
  return (
    <div
      role="tablist"
      data-testid={testId ?? 'tabs'}
      style={{
        display: 'flex',
        gap: 2,
        borderBottom: '1px solid var(--border-subtle)',
        marginBottom: 16,
        overflowX: 'auto',
      }}
    >
      {tabs.map((t) => {
        const active = t.id === activeId;
        return (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={active}
            data-testid={t.testId ?? `tab-${t.id}`}
            onClick={() => onSelect(t.id)}
            style={{
              padding: '10px 16px',
              border: 'none',
              borderBottom: active
                ? '2px solid var(--accent, #2563eb)'
                : '2px solid transparent',
              background: 'transparent',
              color: active ? 'var(--text-primary)' : 'var(--text-tertiary)',
              fontWeight: active ? 600 : 500,
              fontSize: 13.5,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              marginBottom: -1,
            }}
          >
            {t.label}
            {t.badge ? <span style={{ marginLeft: 6 }}>{t.badge}</span> : null}
          </button>
        );
      })}
    </div>
  );
}
